export default {
    popover: 1260,
    popoverIcon: 1261,
    searchPopover: 1265,
    datePicker: 1270,
    dynamicDropdown: 1280,
    loadingOverlay: 1285,
    stickyFooter: 1286,
    menu: 1290,
    drawer: 1290,
    modal: 1300,
    tabGroup: 400,
    toaster: 1400,
};
